import { useBlocker } from '@tanstack/react-router';
import { hasUnsavedChanges } from '../../hooks/useUnsavedChanges';
import { Button, Modal } from '../ui';

export function UnsavedChangesPrompt() {
  const blocker = useBlocker({
    shouldBlockFn: ({ current, next }) =>
      hasUnsavedChanges() &&
      (current.pathname !== next.pathname ||
        (JSON.stringify(current.search) !== JSON.stringify(next.search) &&
          !['/customers', '/suppliers'].includes(current.pathname))),
    enableBeforeUnload: () => hasUnsavedChanges(),
    withResolver: true,
  });
  return (
    <Modal
      isOpen={blocker.status === 'blocked'}
      onClose={() => blocker.reset?.()}
      title="Ungespeicherte Änderungen"
    >
      <p className="text-white/70 mb-6">
        Deine Änderungen wurden noch nicht gespeichert. Möchtest du weiter bearbeiten oder sie
        verwerfen?
      </p>
      <div className="flex flex-wrap justify-end gap-3">
        <Button variant="secondary" onClick={() => blocker.reset?.()}>
          Weiter bearbeiten
        </Button>
        <Button variant="danger" onClick={() => blocker.proceed?.()}>
          Änderungen verwerfen
        </Button>
      </div>
    </Modal>
  );
}
